import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_HISTORYSTATUS,
  CREATE_HISTORYSTATUS,
  DELETE_HISTORYSTATUS,
} from './actionType';

import {
  HistoryStatusApiResponseSuccess,
  HistoryStatusApiResponseError,
} from './action';

import {
  getHistoryStatus as statusHistoryGet,
  createHistoryStatus as statusHistoryCreate,
  deleteHistoryStatus as statusHistoryDelete,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getHistoryStatus(data) {
  try {
    const response = yield call(statusHistoryGet, data.payload.id);
    yield put(HistoryStatusApiResponseSuccess(GET_HISTORYSTATUS, response));
  } catch (error) {
    yield put(HistoryStatusApiResponseError(GET_HISTORYSTATUS, error));
  }
}

function* createHistoryStatus(data) {
  try {
    const response = yield call(statusHistoryCreate, data.payload.data);
    yield put(HistoryStatusApiResponseSuccess(CREATE_HISTORYSTATUS, response));
    notifySuccess('Evento adicionado com sucesso!');
  } catch (error) {
    yield put(HistoryStatusApiResponseError(CREATE_HISTORYSTATUS, error));
    notifyError('Erro ao adicionar evento!');
  }
}

function* deleteHistoryStatus(data) {
  try {
    const response = yield call(statusHistoryDelete, data.payload.id);
    yield put(HistoryStatusApiResponseSuccess(DELETE_HISTORYSTATUS, response));
    notifySuccess('Evento deletado com sucesso!');
  } catch (error) {
    yield put(HistoryStatusApiResponseError(DELETE_HISTORYSTATUS, error));
    notifyError(error.response.data.message);
  }
}

export function* watchGetHistoryStatus() {
  yield takeEvery(GET_HISTORYSTATUS, getHistoryStatus);
}

export function* watchCreateHistoryStatus() {
  yield takeEvery(CREATE_HISTORYSTATUS, createHistoryStatus);
}

export function* watchDeleteHistoryStatus() {
  yield takeEvery(DELETE_HISTORYSTATUS, deleteHistoryStatus);
}

function* HistoryStatusSaga() {
  yield all([fork(watchGetHistoryStatus)]);
  yield all([fork(watchCreateHistoryStatus)]);
  yield all([fork(watchDeleteHistoryStatus)]);
}

export default HistoryStatusSaga;
